import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getFieldSuggestions } from './fieldSuggestionsService';

export const FIELD_SUGGESTIONS_QUERY_KEY = 'fieldSuggestions';

/** @type {number} */
export const FIELD_SUGGESTIONS_MIN_CHARS = 1;

/**
 * Field suggestions GET query
 * @param {string | null | undefined} suggestionsUrl
 * @param {string} search
 * @param {Omit<import('@tanstack/react-query').UseQueryOptions<string[], Error>, 'queryKey' | 'queryFn'>} [options]
 * @returns {import('@tanstack/react-query').UseQueryResult<string[], Error>}
 */
export const useFieldSuggestionsQuery = (suggestionsUrl, search, options = {}) => useQuery({
  queryKey: [FIELD_SUGGESTIONS_QUERY_KEY, suggestionsUrl, search],
  queryFn: () => getFieldSuggestions(/** @type {string} */ (suggestionsUrl), search),
  enabled: Boolean(suggestionsUrl) && search.length >= FIELD_SUGGESTIONS_MIN_CHARS,
  placeholderData: keepPreviousData,
  ...options,
});
